export default __webpack_public_path__ + "images/55acb3e397ccc3adc631894a196001ce-edm_small.webp";